/* eslint-disable */
import getDispositifType from '@/services/import/patrimoine/parametrage/getTypeDispositif';
import getDispositifSupport from '@/services/import/patrimoine/parametrage/getSupportDispositif';
import getTypeMateriel from '@/services/import/patrimoine/parametrage/getTypeMateriel';
import getFormatMateriel from '@/services/import/patrimoine/parametrage/getFormatMateriel';
import getPatrimoineConstruit from '@/services/import/patrimoine/getPatrimoineConstruit';
import { ADRESSE, CLIENT } from '@/configuration/gabed/emplacement/emplacementConf';
import { create as createEmplacement } from '@/api/gabed/emplacement/emplacementAdresse';
import { create as createEmplacementClient } from '@/api/gabed/emplacement/emplacementClient';
import { create as createDispositif } from "@/api/gabed/dispositif/index";
import { create as createMateriel } from "@/api/gabed/materiel/index";
import getAngleVisionMateriel
  from '@/services/import/patrimoine/parametrage/getAngleVisionMateriel';
import getFaceMotifNonCom from '@/services/import/patrimoine/parametrage/getFaceMotifNonCom';
import getTiers from '@/services/import/patrimoine/parametrage/getTiers';
import getTypeTaxationTlpe from '@/services/import/patrimoine/parametrage/getTypeTaxationTlpe';
import getLocalisationMateriel from '@/services/import/patrimoine/parametrage/getLocalisationMateriel';
import getTiersByReferenceExterne from '@/services/import/patrimoine/parametrage/getTiersByReferenceExterne';
import verificationDescriptionTlpe
  from '@/services/import/patrimoine/parametrage/verificationDescriptionTlpe';

export async function makePatrimoineGenerated(lignes) {
  await getDispositifType(lignes.map((l => l.typeDispositif)));
  await getDispositifSupport(lignes.map((l => l.supportDispositif)));
  await getTypeMateriel(lignes.map((l => l.typeMateriel)));
  await getFormatMateriel(lignes.map((l => l.formatMateriel)));
  await getAngleVisionMateriel(lignes.map((l => l.angleVisionMateriel)));
  await getLocalisationMateriel(lignes.map((l => l.localisationMateriel)));
  await getFaceMotifNonCom(lignes.map((l => l.motifNonCommercialisation)));
  verificationDescriptionTlpe(lignes.map((l => l.descriptionTlpeMateriel)));

  const informationApiReference = {
    fournisseurElectricite: await getTiers(lignes.filter((l) => { return l.fournisseurElec && l.fournisseurElec.trim().length > 0; }).map((l => l.fournisseurElec))),
    confrereDispositif: await getTiers(lignes.filter((l) => { return l.confrereDispositif && l.confrereDispositif.trim().length > 0; }).map((l => l.confrereDispositif))),
    collectivite: await getTiers(lignes.filter((l) => { return l.collectiviteTlpe && l.collectiviteTlpe.trim().length > 0; }).map((l => l.collectiviteTlpe))),
    proprietaire: await getTiers(lignes.filter((l) => { return l.proprietaireDispositif && l.proprietaireDispositif.trim().length > 0; }).map((l => l.proprietaireDispositif))),
    typeTaxationTlpe: await getTypeTaxationTlpe(lignes.filter((l) => { return l.typeTaxationTlpe && l.typeTaxationTlpe.trim().length > 0; }).map((l => l.typeTaxationTlpe))),
    clients: lignes.filter(l => l.type === CLIENT).length ? await getTiersByReferenceExterne(lignes.filter((l) => l.codeClient?.trim().length > 0).map((l => l.codeClient))) : [],
  }

  const patrimoine = getPatrimoineConstruit(lignes, informationApiReference);
  return patrimoine;
}

export async function makePatrimoineImport(patrimoine) {
  for (const emplacement of patrimoine) {
    let emplacementCreated = null
    switch (emplacement.type) {
      case ADRESSE:
        emplacementCreated = (await createEmplacement(emplacement)).data.result;
        break;
      case CLIENT:
        emplacementCreated = (await createEmplacementClient(emplacement)).data.result;
        break;
      default:
        break;
    }

    for (const dispositif of emplacement.dispositifs) {
      dispositif.emplacementId = emplacementCreated.id;
      dispositif.nomenclature = "{}";
      const dispositifCreated = (await createDispositif(dispositif)).data.result;
      dispositif.materiels.sort((a, b) => a.disposition.toString().localeCompare(b.disposition.toString()));

      for (const materiel of dispositif.materiels) {
        materiel.dispositifId = dispositifCreated.id;
        await createMateriel(materiel);
      }
    }
  }
}
